export enum SettingsTabType {
  WIFI_SETTINGS = 'wifi-settings',
  PDI_SETTINGS = 'pdi-settings',
  OUTLET_SETTINGS = 'outlet-settings',
}
